export const ROUTES_PATHS = {
  root: "/",
  login: "/login",
  activateAccount: "/activate-account",
  resetPassword: "/reset-password",
  animations: "/animations",
  singleOwners: "/users/single-owners",
  singleOwnersDetails: "/users/single-owners/:id",
  fleetOwners: "/users/fleet-owners",
  fleetOwnersDetails: "/users/fleet-owners/:id",
  drivers: "/users/drivers",
  driversDetails: "/users/drivers/:id",
  userDetailsParam: ":id",
  pendingDrivers: "/users/pending-drivers",
  liveRewards: "/rewards/live-rewards",
  addRewards: "/rewards/live-rewards/add",
  rewardsDetails: "/rewards/live-rewards/:id",
  deletedRewards: "/rewards/deleted-rewards",
  deletedRewardsDetails: "/rewards/deleted-rewards/:id",
  rewardsDetailsParam: ":id",
  trips: "/trips",
  tripsDrivers: "/trips/drivers",
  tripsOwners: "/trips/owners",
  tripsDriversDetails: "/trips/drivers/:id",
  tripsOwnersDetails: "/trips/owners/:id",
  tripsDetailsParam: ":id",
  faqMobile: "/:locale/faq",
  verificationRequestsPending: "/verifications-requests/pending",
  verificationRequestsHistory: "/verifications-requests/history",
  standardAdmins: "/admins/standard-admins",
  addStandardAdmins: "/admins/standard-admins/add",
  referralsList: "/referral-program/referral-list",
  referralsRewards: "/referral-program/referral-rewards",
  services: "/services",
  serviceCenters: "/services/service-centers",
  marketplace: "/services/marketplace",
  offers: "/offers",
  offersDetails: "/offers/:id",
  offersDetailsParam: ":id",
  offersAdd: "/offers/add",
  offersEdit: "/offers/:id/edit",
  addAnimation: "/animations/add",
  animationDetails: "/animations/:id",
  editAnimation: "/animations/:id/edit",
  animationDetailsParam: ":id",
  agentChat: "/agent-chat",
  oauthCallback: "/oauth/callback",
  challenges: "/challenges",
  challengesAdd: "/challenges/add",
  challengesAddParam: "add",
  challengesDetails: "/challenges/:id",
  challengesDetailsParam: ":id",
  challengesEdit: "/challenges/:id/edit",
  challengesEditParam: ":id/edit",
  challengesDuplicate: "/challenges/:sourceId/duplicate",
  challengesDuplicateParam: ":sourceId/duplicate",
  challengesSourceIdParam: ":sourceId",
};
